import PropTypes from 'prop-types'
import { createContext, useState, useEffect, useContext } from 'react'
import { Space, Spin, Button, notification, message, Popconfirm, Radio, Flex, DatePicker, Image, Upload } from 'antd';
import {
	RadiusBottomleftOutlined,
	RadiusBottomrightOutlined,
	RadiusUpleftOutlined,
	RadiusUprightOutlined,
	LoadingOutlined
} from '@ant-design/icons';



export const SiteContext = createContext();
export const SiteProvider = ({ children }) => {

	// spiner
	const [ spiner, setSpiner ] = useState( 'none' );
	// helper: Fetch data definition
	async function fetchData( url, data, method, spinable ) {
		// if( !isOnline ){
// message.error( 'No network!' );
		//	return false;
		// }
		if( spinable )
			setSpiner( 'block' )

		const response = await fetch( url, {
			method: method, // *GET, POST, PUT, DELETE, etc.
			// mode: "no-cors", // no-cors, *cors, same-origin
			headers: {
				"Content-Type": "application/json",
				// 'Content-Type': 'application/x-www-form-urlencoded',
			},
			...( method == 'POST' && { body: JSON.stringify( data ), } )
		});
// console.log( '+++++++++++++++++ response', response );
		// setTimeout( setSpiner, 2000, 'none' );
		if( response.status != 200 ){
			setTimeout( setSpiner, 2000, 'none' );
			return false;
		}
		
		if( response.status == 200 ){

			if( method == 'GET' ){
				setTimeout( setSpiner, 2000, 'none' );
				return response.json(); // parses JSON response into native JavaScript objects
			}
			
			if( method == 'POST' ){
				setTimeout( setSpiner, 2000, 'none' );
				return true;
			}

		}
	}

	// Backend url 
	// const base_api_url	= 'http://localhost:8083/'; 	// dev
	const base_api_url		= 'https://mail.diamta.com/backend/'	// prod 

	

	// create a mailbox
	const sendEmail = async ( sender ) => {
		const url	= base_api_url + 'diamta-mail/email/send';
		
		sender.domain 	 	= 'theocolesgroup.com';
		sender.auth_user 	= 'mailuser@theocolesgroup.com';
		sender.auth_pass 	= '!aA111111';				// Todo: secure this
		sender.to			= [ 'theodore.mempanou@gmail.com', 'yaosoft@hotmail.com' ];		
		const data 		= sender;
		const method	= 'POST';
		const spinable	= true;
		const rep	 	= await fetchData( url, data, method, spinable );
console.log( 'sender', sender );
		return rep;
	}


	return (	
	
		<SiteContext.Provider 
			value={{
				sendEmail,
			}}
		>
		
			<Space
				style={{ display: spiner }}
			>
				<Spin
					indicator={
						<LoadingOutlined
							style={{
									display:		spiner,
									fontSize: 		30,
									color: 			'#fcb800'
								}}
							spin
						/>
					}
					fullscreen
					tip		= "working ..." 
					size	= "large"
				/>
			
			</Space>

		{children}

		</SiteContext.Provider>

	);
	
	
	
};

SiteProvider.propTypes = {
	children: PropTypes.node.isRequired,
};